import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { ValidatorForm, TextValidator, SelectValidator} from 'react-material-ui-form-validator';
import Moment from 'moment';
import MenuItem from '@material-ui/core/MenuItem';
import Checkbox from '@material-ui/core/Checkbox';
import Fade from 'react-reveal/Fade';
import ReactGA from 'react-ga';
import { setDigitalData } from '../../Utilities/Utils.js';

//TODO - see if you can leave having to use materialUI entirely
//this is a really bunk way of styling things

import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { withStyles } from '@material-ui/core/styles';

import './CreatePass.css';


const theme = createMuiTheme({
    palette: {
        primary: {
            light: "#3CB6CE",
            main: "#3CB6CE",
            dark: "#3CB6CE",
            contrastText: "#3CB6CE"
        },
        text: {
            primary:"#FFF" ,
            secondary: "#FFF"
        },
        action: {
            active:"#FFF"
        }
    },
    typography : {
        fontFamily: ['Roboto Condensed','Roboto','Helvetica'].join(','),
        fontSize: "20",
    }
});
const styles = {
    root: {
        color: "#FFF",
        '&$checked': {
            color: "#D52B1E",
        },
    },
    checked: {},
    resize:{
    },
    labelResize:{
    },
    labelSelectResize:{
    },
    menuItem:{
        color:'black',
    },
    underline: {
        color: theme.palette.common.white,
        borderBottom: theme.palette.common.white,
        '&:after': {
            borderBottom: `2px solid ${theme.palette.common.white}`,
        },
        '&:focused::after': {
            borderBottom: `2px solid ${theme.palette.common.white}`,
        },
        '&:before': {
            borderBottom: `1px solid ${theme.palette.common.white}`,
        },
        '&:hover:not($disabled):not($focused):not($error):before': {
            borderBottom: '2px solid rgb(255, 255, 255) !important',
        },
        '&$disabled:before': {
            borderBottom: `1px dotted ${theme.palette.common.white}`,
        },
	},
    disabled: {},
    focused: {},
    error: {}
}




class DGRCreatePass extends Component {

    componentDidMount(){
        this.props.DGRBackgroundStore.showBlurAndHeader()
        this.props.DGRStore.setValue( 'membership_flow' , false);
        setDigitalData( 'personal info', this.props.DGRStore.club_number );
    }

    handleChange = (e) => {
        this.props.DGRStore.setValue(e.target.name,e.target.value);
    }
    handleSMSChange = (e) => {
        this.props.DGRStore.setValue(e.target.name,e.target.checked);
    }

    handleSubmit = (e) => {
        // First, make sure they entered a valid birthday.
        var year = this.props.DGRStore.values.year,
            month = ( this.props.DGRStore.values.month + 1 ),
            day = this.props.DGRStore.values.day,
            datestr = '' + year + '-' + ( month < 10 ? '0' : '' ) + month + '-' + ( day < 10 ? '0' : '' ) + day,
            date = Moment( datestr );

        if ( !date.isValid() ) {
            alert('Please enter a valid Date of Birth.');
            e.preventDefault();
            return false;
        }

        ReactGA.set({ dimension7: new Date().getTime() });
        ReactGA.event({
            category: 'Create Pass',
            action: 'Create Pass Form'
        });

        // Need to reset some of the booleans, in case they were stored from a previous attempt.
        this.props.DGRStore.values.is_waiver_signed = false;
        this.props.DGRStore.values.is_expired = false;
        this.props.DGRStore.values.is_guest = false;
        this.props.DGRStore.values.days_left = 0;

        this.props.history.push('sign_waiver');
    }

    popupInClubPrivacy = (e) => {

        ReactGA.set({ dimension7: new Date().getTime() });
        ReactGA.event({
            category: 'Create Pass',
            action: 'In-Club Privacy Policy'
        });

        e.preventDefault();
        e.stopPropagation();
        this.props.DGRModalStore.setURL('https://www.24hourfitness.com/membership/inclub_privacy_policy.html')
        this.props.DGRModalStore.setSection('iframe')
        this.props.DGRModalStore.setCloseVisible()
        this.props.DGRModalStore.openModal()
    }

    popupWebsitePrivacy = (e) => {

        ReactGA.set({ dimension7: new Date().getTime() });
        ReactGA.event({
            category: 'Create Pass',
            action: 'Website Privacy Policy'
        });

        e.preventDefault();
        e.stopPropagation();
        this.props.DGRModalStore.setURL('https://www.24hourfitness.com/company/policies/privacy/privacy_policy.html')
        this.props.DGRModalStore.setSection('iframe')
        this.props.DGRModalStore.setCloseVisible()
        this.props.DGRModalStore.openModal()
    }

    popupTerms = (e) => {

        ReactGA.set({ dimension7: new Date().getTime() });
        ReactGA.event({
            category: 'Create Pass',
            action: 'SMS Terms'
        });

        e.preventDefault();
        e.stopPropagation();
        this.props.DGRModalStore.setURL('https://www.24hourfitness.com/company/policies/sms/terms.html')
        this.props.DGRModalStore.setSection('iframe')
        this.props.DGRModalStore.setCloseVisible()
        this.props.DGRModalStore.openModal()
    }

    render(){

        const { classes } = this.props;
        const { email, first_name, last_name, year, day, month, phone, zipcode, gender, is_sms_allowed } = this.props.DGRStore.values;

        //TODO
        //date stuff that is shared with enterpass.js - refactor to single component, or least utils
        const fillRange = (start, end) => {
            return Array(end - start + 1).fill().map((item, index) => start + index);
        };

        const daysArray = fillRange(1, 31);
        const days = daysArray.map( (day, i ) => {
            return (
                <MenuItem
                    classes={{
                        root: classes.menuItem
                      }}
                    key={i}
                    value={day}
                 >{day}</MenuItem>
            );
        })
        const monthsArray = fillRange(0, 11);
        const months = monthsArray.map( (month, i) => {
            var momentInstance = Moment
            const monthName = momentInstance.months(i)
            return (
                <MenuItem
                    classes={{
                        root: classes.menuItem
                      }}
                    key={i}
                    value={i}
                 >{monthName}</MenuItem>
            )
        })
        var yearsArray = fillRange( ( new Date().getFullYear() - 100 ), new Date().getFullYear() );
        yearsArray = yearsArray.reverse()
        const years = yearsArray.map( (year, i ) => {
            return (
                <MenuItem
                    classes={{
                        root: classes.menuItem
                      }}
                    className="year"
                    key={i} value={year}
                    >{year}
                </MenuItem>
            );
        })
        return (

            <div className="createPass">
                <Fade>
                <MuiThemeProvider theme={theme}>
                <div className="createPassTitleText">
                    <h2>Tell us a bit  more about yourself.</h2>
                </div>
                <div className="createPassTitleSubText">
                    <div className="subText">
                         Photo identification required.  If under 18 years of age, a parent or guardian must be present.
                    </div>
                </div>


            <ValidatorForm
                className = "createPassItems"
                ref="form"
                autoComplete="off"
                instantValidate = {false}
                onSubmit={this.handleSubmit}
                onError={errors => console.log(errors)}
            >
                <input autoComplete="off" name="hidden" type="text" style={{display:'none'}}></input>
                <div className="row">
                <TextValidator
                    autoComplete="off"
                    label="First Name"
                    onChange={this.handleChange}
                    name="first_name"
                    id="firstNameField"
                    value={first_name}
                    validators={['required','matchRegexp:^([^0-9]*)$']}
                    errorMessages={['This field is required', 'No numbers allowed']}
                    className="fname"
                    placeholder="eg: John"
                    InputProps={{
                        classes: {
                            input: classes.resize,
                            underline: classes.underline
                        },
                    }}
                    InputLabelProps={{
                        classes: {
                            root: classes.labelResize,
                        },
                    }}
                />
                <TextValidator
                    autoComplete="off"
                    label="Last Name"
                    onChange={this.handleChange}
                    name="last_name"
                    id="lastNameField"
                    className="lname"
                    value={last_name}
                    validators={['required','matchRegexp:^([^0-9]*)$']}
                    errorMessages={['This field is required', 'No numbers allowed']}
                    placeholder="eg: Smith"
                    InputProps={{
                        classes: {
                            input: classes.resize,
                            underline: classes.underline
                        },
                    }}
                    InputLabelProps={{
                        classes: {
                            root: classes.labelResize,
                        },
                    }}
                />
                <SelectValidator
                    className="gender"
                    label="Gender"
                    name="gender"
                    id="genderField"
                    value={gender}
                    onChange={this.handleChange}
                    InputProps={{
                        name: 'gender',
                        id: 'gender',
                        classes: {
                            underline: classes.underline
                        }
                    }}
                    validators={['required']}
                    errorMessages={['This field is required' ]}
                >
                    <MenuItem
                        classes={{
                            root: classes.menuItem
                          }}
                        value="f">Female</MenuItem>
                    <MenuItem
                        classes={{
                            root: classes.menuItem
                          }}
                        value="m">Male</MenuItem>
                    <MenuItem
                        classes={{
                            root: classes.menuItem
                          }}
                        value="u">Unspecified</MenuItem>
                </SelectValidator>
                </div>
                <div className="row">
                <TextValidator
                    label="Email"
                    autoComplete="off"
                    onChange={this.handleChange}
                    name="email"
                    id="emailField"
                    className="email"
                    value={email}
                    validators={['required', 'isEmail']}
                    errorMessages={['This field is required', 'email is not valid']}
                    placeholder="eg: name@domain.com"
                    InputProps={{
                        classes: {
                            input: classes.resize,
                            underline: classes.underline
                        },
                    }}
                    InputLabelProps={{
                        classes: {
                            root: classes.labelResize,
                        },
                    }}
                />

                <TextValidator
                    label="Phone"
                    autoComplete="off"
                    onChange={this.handleChange}
                    name="phone"
                    id="phoneField"
                    className="phone"
                    value={phone}
                    validators={['required','matchRegexp:^\\D?(\\d{3})\\D?\\D?(\\d{3})\\D?(\\d{4})$']}
                    errorMessages={['This field is required', 'Enter a valid 10-digit phone number' ]}
                    placeholder="eg: 123-456-3828"
                    InputProps={{
                        classes: {
                            input: classes.resize,
                            underline: classes.underline
                        },
                    }}
                    InputLabelProps={{
                        classes: {
                            root: classes.labelResize,
                        },
                    }}
                />
                <TextValidator
                    label="Zip"
                    autoComplete="off"
                    onChange={this.handleChange}
                    name="zipcode"
                    id="zipcodeField"
                    className="zipcode"
                    value={zipcode}
                    validators={['required','matchRegexp:^[0-9]{5}(-[0-9]{4})?$']}
                    errorMessages={['This field is required', 'Enter a valid US zipcode'  ]}
                    placeholder="eg: 12345"
                    InputProps={{
                        classes: {
                            input: classes.resize,
                            underline: classes.underline
                        },
                    }}
                    InputLabelProps={{
                        classes: {
                            root: classes.labelResize,
                        },
                    }}
                />
                </div>
                <div className="row">
                <div className='birthLabel' >Date of Birth</div>
                <SelectValidator
                    name="year"
                    className="birthYear"
                    value={year}
                    onChange={this.handleChange}
                    InputProps={{
                        classes: {
                            underline: classes.underline
                        },
                        name: 'year',
                        id: 'year',
                    }}
                >
                    {years}
                </SelectValidator>
                <SelectValidator
                    name="month"
                    className="birthMonth"
                    value={month}
                    onChange={this.handleChange}
                    InputProps={{
                        classes: {
                            underline: classes.underline
                        },
                        name: 'month',
                        id: 'month',
                    }}
                >
                    {months}
                </SelectValidator>
                <SelectValidator
                    name="day"
                    className="birthDay"
                    value={day}
                    onChange={this.handleChange}
                    InputProps={{
                        classes: {
                            underline: classes.underline
                        },
                        name: 'day',
                        id: 'day',
                    }}
                >
                    {days}
                </SelectValidator>
                </div>
                <div className='smsTitle'>Receive FREE digital workouts and messages via text</div>

                <div className='smsAccept'>
                    <Checkbox
                        classes={{
                            root: classes.root,
                            checked: classes.checked,
                        }}
                        name="is_sms_allowed"
                        checked={is_sms_allowed}
                        onChange={this.handleSMSChange}
                        value={String(is_sms_allowed)}
                    />
                    <div className="smsBody">
                      <span className="smsBold">
                        Yes! I'd like to receive automated marketing text messages and workouts from 24 Hour Fitness to the mobile number provided.
                      </span>
                      <span className="disclaimerText">
                        &nbsp;Consent is not required to purchase goods or services.
                        You further understand that your information will be used as described here
                        and according to the 24 Hour Fitness In-Club Privacy Policy:&nbsp;
                        <a href="#" onClick={ this.popupInClubPrivacy }>Click here</a>.
                        Website Privacy Policy:&nbsp;
                        <a href="#" onClick={ this.popupWebsitePrivacy }>Click here</a>.
                        SMS Terms & Conditions:&nbsp;
                        <a href="#" onClick={ this.popupTerms }>Click here</a>.
                        Up to 3msg/wk. First text sent within two days after opt-in. Message and data rates may apply.
                        Reply STOP to 24HOUR (244687) to end. Reply HELP to 24HOUR (244687) for help. Not all carriers covered.
                      </span>
                    </div>
                </div>

                <div className="submitCreatePass">
                    <button className="bigButton" type="submit">Next</button>
                </div>
            </ValidatorForm>
             </MuiThemeProvider>
            </Fade>

            </div>
        )
    }
}

DGRCreatePass = inject('DGRStore','DGRModalStore', 'DGRBackgroundStore')(observer(DGRCreatePass))
//export default DGRCreatePass ;
export default withStyles(styles)(DGRCreatePass);



// WEBPACK FOOTER //
// ./src/components/DGR/CreatePass/CreatePass.js